import { PanelShell, Badge, ApiResourceView, DJSEMApiClient, useApiResource } from "../index";

interface RightsItem { assetId?: string; state?: string; }

/**
 * Assets module — shows generated/imported assets grouped by rights state, so users can see at
 * a glance which assets are cleared for use versus restricted or AI-generated and uncleared.
 *
 * @param client - The API client used to fetch the rights list.
 * @returns A panel of asset counts broken down by rights state (or the loading/error/empty view).
 */
export function AssetsModule({ client }: { client: DJSEMApiClient }) {
  const res = useApiResource(() => client.listRights(), [], (d) => (d.items?.length ?? 0) === 0);
  return (
    <ApiResourceView
      resource={res}
      empty={{ title: "No assets yet", detail: "Generated and imported assets appear here with their rights state." }}
      render={(data) => {
        const items = (data.items ?? []) as unknown as RightsItem[];
        const counts = items.reduce((acc: Record<string, number>, it) => { const s = it.state ?? "unknown"; acc[s] = (acc[s] ?? 0) + 1; return acc; }, {});
        return (
          <PanelShell title="Assets by rights state">
            {Object.entries(counts).map(([state, n]) => (
              <div key={state} style={{ display: "flex", justifyContent: "space-between", padding: "3px 0" }}>
                <span>{state}</span><Badge tone={state === "restricted" || state === "ai_generated_uncleared" ? "warn" : "ok"}>{n}</Badge>
              </div>
            ))}
          </PanelShell>
        );
      }}
    />
  );
}
